/** Имя и фамилия без отчества — первые два слова */
export function shortDisplayName(fullName: string): string {
  const p = fullName.trim().split(/\s+/).filter(Boolean)
  if (p.length <= 2) return fullName.trim()
  return `${p[0]} ${p[1]}`
}
